module.exports = __webpack_public_path__ + "assets/F-desk-manage.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/F-desk-manage.png
// module id = 1223
// module chunks = 7